import React from 'react'
import { Helmet } from 'react-helmet'
import NumberCards from '../../Components/NumberCards/NumberCards.jsx'
import Activities from './../../Components/Activities/Activities.jsx';
import PageTitle from '../../Components/PageTitle/PageTitle.jsx';

export default function About() {
    return (
        <div>
            <Helmet>
                <title>Hossam Hatem</title>
            </Helmet>
            
            <PageTitle title="About Me" />

            <p className='mr-28 mt-3'>
                I am a Software Engineer with expertise in full stack web development. My focus is on delivering modern and responsive websites that are not only visually appealing but also robust and efficient. <br /> By working closely with your team, I ensure your brand's identity is reflected in the website's design and functionality. Having previously worked with various companies, I can contribute to creating impactful websites that help drive business outcomes. Let me help you improve your digital presence.
                <br /> Feel free to explore my portfolio to discover my latest projects and learn more about my skills and experience in the field.
            </p>

            <NumberCards />

            <div className='mt-7'>
                <h2 className='font-semibold text-[#19284D] text-2xl'>What I'm Doing</h2>
                <Activities />
            </div>

        </div>
    )
}
